import React from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "../../../components/auth-layout-components/login-form/LoginForm";
import { loginUser } from "../../../services/auth-service/authService";
import { toastError, toastSuccess } from "../../../utils/toast";
import { encodeWithSalt } from "../../../utils/encodeFunctions";
import { useMasterData } from "../../../hooks/useMasterData";
import logoIconSvg from "../../../assets/images/LogoIcon.svg";

interface LoginPageProps {
  title:      string;
  navigateTo: string;
  regPage:    string;
}

function LoginPage({ title, navigateTo, regPage }: LoginPageProps) {
  const navigate  = useNavigate();
  const { masterData } = useMasterData();

  async function handleSubmit(
    e: React.FormEvent<HTMLFormElement>,
    formData: any
  ) {
    e.preventDefault();
    try {
      const loginData = await loginUser({ ...formData });
      toastSuccess("Login Successful!");
      sessionStorage.setItem("authToken", loginData.token);
      sessionStorage.setItem("loggedIn", encodeWithSalt(JSON.stringify(true)));
      sessionStorage.setItem("role", encodeWithSalt(loginData.role));
      navigate(navigateTo);
    } catch (error: any) {
      toastError(error.response?.data?.message ?? "Login failed");
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #fef2f2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem 1rem",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#ffffff",
          borderRadius: 20,
          boxShadow: "0 8px 40px rgba(0,0,0,0.10)",
          padding: "2.5rem 2rem 2rem",
          border: "1.5px solid #f0f4f8",
        }}
      >
        {/* Brand */}
        <div className="text-center mb-4">
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
            background: "#ed1b24",
            borderRadius: 14,
            marginBottom: "0.75rem",
            boxShadow: "0 4px 16px rgba(237,27,36,0.3)",
          }}>
            <img src={logoIconSvg} alt="AdsOne" style={{ width: 34, height: 34, objectFit: "contain" }} />
          </div>
          <h4 style={{ fontWeight: 800, color: "#1e293b", marginBottom: "0.25rem", letterSpacing: "-0.03em" }}>
            {title} Login
          </h4>
          <p style={{ color: "#94a3b8", fontSize: "0.875rem", margin: 0 }}>
            Welcome back — sign in to continue
          </p>
        </div>

        <LoginForm regPage={regPage} handleSubmit={handleSubmit} />
      </div>
    </div>
  );
}

export default LoginPage;
